import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import TextControlObligado from '../components/customizedInputs/TextControlObligado';
import { values } from 'pdf-lib';

const ObligadoForm = () => {
  let { id } = useParams();
  const tipo_doc = ["dni", "lc", "le"]
  const estado_civil = ["soltero", "casado", "viudo", "divorciado"]
  const [usuario, setUsuario] = useState();
  const [saving, setSaving] = useState(false);

  const [datosUsuario, setDatosUsuario] = useState({
    // "usuario":{"autocompletar":true, "tipo":"", "atributo":"usuario", "value":""},
    "email":{"autocompletar":true, "tipo":"", "atributo":"email", "requerido": false},
    // "leyend":{"tipo":"leyend", "value": "La clave se genera automáticamente y se envía por mail"},
    // "documentos":{"autocompletar":false, "tipo":"file", "atributo":"documentos", "value":""},
    // "registro_pdf_id":{"autocompletar":false, "tipo":"hidden", "atributo":"preferencias_usuario.registro_pdf_id"},
    });

  const [camposBasicos, setCamposBasicos] = useState({
    "nombre":{"autocompletar":true, "tipo":"", "atributo":"nombre", "requerido": false},
    "apellido":{"autocompletar":true, "tipo":"", "atributo":"apellido", "requerido": false},
    "f_nacimiento":{"autocompletar":true, "label": "Fecha Nacimiento","tipo":"date", "atributo":"preferencias_usuario.f_nacimiento", "requerido": true},
    "tipo_doc":{"autocompletar":false,"tipo":"select", "options":tipo_doc, "atributo":"preferencias_usuario.tipo_doc", "requerido": true},
    "documento_identidad":{"autocompletar":true, "tipo":"", "atributo":"documento_identidad", "requerido": false},
    "nacionalidad":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.nacionalidad", "requerido": false},
    "telefono_particular":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.telefono_particular", "requerido": false},
    "telefono_laboral":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.telefono_laboral", "requerido": false},
    "estado_civil":{"autocompletar":false,"tipo":"select", "options":estado_civil, "atributo":"preferencias_usuario.estado_civil", "requerido": true},
    "nombre_conyuge":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.nombre_conyuge", "requerido": false},
    "apellido_conyuge":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.apellido_conyuge", "requerido": false},
    "cargo":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.cargo", "requerido": false},
    "organismo":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.organismo", "requerido": false},
    // "leyend1":{"tipo":"leyend", "value": "Hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente desde"},
    "f_cargo_desde":{"autocompletar":true,"tipo":"date", "label": "Cargo Desde", "atributo":"preferencias_usuario.f_cargo_desde", "requerido": false},
    "numero_alta_norma_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.numero_alta_norma_legal", "requerido": false},
    // "leyend2":{"tipo":"leyend", "value": "Si corresponde, hacer saber que me desempeño/desempeñé en el cargo indicado precedentemente hasta"},
    "f_cargo_hasta":{"autocompletar":true,"tipo":"date", "label": "Cargo Hasta", "atributo":"preferencias_usuario.f_cargo_hasta", "requerido": false},
    "numero_baja_norma_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.numero_baja_norma_legal", "requerido": false},
  });


  const [camposDomicilioReal, setCamposDomicilioReal] = useState({
    "calle_real":{"autocompletar":true,"tipo":"", "atributo":"preferencias_usuario.calle_real"},
    "barrio_real":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.barrio_real"},
    "localidad_real":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.localidad_real"},
    "cp_real":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.cp_real"}
    });

  const [camposDomicilioLegal, setCamposDomicilioLegal] = useState({
    "calle_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.calle_legal"},
    "barrio_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.barrio_legal"},
    "localidad_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.localidad_legal"},
    "cp_legal":{"autocompletar":true, "tipo":"", "atributo":"preferencias_usuario.cp_legal"},
  });


  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [registroPdf, setRegistroPdf] = useState({})

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'MesaEntrada'){
      setRenderHTML(true)
      fetchRegistroPDF(id)
      // nuevoUsuario()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchRegistroPDF = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('registro_pdfs', id);
      const data_usuario = await resourcesServices.obtenerResourcePorId('usuarios/obtenerPorDocumento', data.documento_identidad);
      setUsuario(data_usuario)
      // const updatedDatosUsuario = datosUsuario
      // setDatosUsuario({...datosUsuario,
      //   ["registro_pdf_id"]: {...updatedDatosUsuario["registro_pdf_id"], ...{value: data.id}}
      // });

      const updatedCamposBasicos = { ...camposBasicos};

      for (const key in updatedCamposBasicos) {
        if (Object.hasOwnProperty.call(updatedCamposBasicos, key)) {
          const value = data.cleaned_fields[key]
          updatedCamposBasicos[key].value = value;
          if(updatedCamposBasicos[key].atributo === undefined){
            updatedCamposBasicos[key].atributo = key
          }
        }
      }

      setCamposBasicos(updatedCamposBasicos);


      const updatedCamposDomicilioReal = { ...camposDomicilioReal };
      for (const key in updatedCamposDomicilioReal) {
        if (Object.hasOwnProperty.call(updatedCamposDomicilioReal, key)) {
          const value = data.cleaned_fields[key]
          updatedCamposDomicilioReal[key].value = value;
          if(updatedCamposDomicilioReal[key].atributo === undefined){
            updatedCamposDomicilioReal[key].atributo = key
          }
        }
      }
      setCamposDomicilioReal(updatedCamposDomicilioReal);


      const updatedCamposDomicilioLegal = { ...camposDomicilioLegal };
      for (const key in updatedCamposDomicilioLegal) {
        if (Object.hasOwnProperty.call(updatedCamposDomicilioLegal, key)) {
          const value = data.cleaned_fields[key]
          updatedCamposDomicilioLegal[key].value = value;
          if(updatedCamposDomicilioLegal[key].atributo === undefined){
            updatedCamposDomicilioLegal[key].atributo = key
          }
        }
      }
      setCamposDomicilioLegal(updatedCamposDomicilioLegal);


      const updateddatosUsuario = { ...datosUsuario };
      for (const key in updateddatosUsuario) {
        if (Object.hasOwnProperty.call(updateddatosUsuario, key)) {
          const value = data.cleaned_fields[key]
          updateddatosUsuario[key].value = value;
          if(updateddatosUsuario[key].atributo === undefined){
            updateddatosUsuario[key].atributo = key
          }
        }
      }
      setDatosUsuario(updateddatosUsuario);


    } catch (error) {
      errorMessage(error)
    }
  };


  const guardarObligado = async () => {
    try {
      setSaving(true)

      const newObject = {...camposBasicos, ...camposDomicilioReal, ...camposDomicilioLegal, ...datosUsuario}

      const attributeName = 'usuario'
      const formData =  new FormData();
      for(const [_, value] of Object.entries(newObject)){
        if(value.atributo){
          if (value.atributo.includes('.')) {
            const [parentKey, childKey] = value.atributo.split('.');

            formData.append(`${attributeName}[${parentKey}_attributes][${childKey}]`, value.value || '')

          } else {
            formData.append(`${attributeName}[${value.atributo}]`, value.value || '')
          }
        }
      }

      formData.append(`${attributeName}[registro_pdf_id]`, id)

      await resourcesServices.crearResource('usuarios/crearActualizarObligado', formData);

      setSaving(false)
      alert("Obligado creado. Se le envió al obligado un email con su usuario y clave")
      navigate(`/obligados`);

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const validarInformacion = async () => {
    try {
      setSaving(true)

      const newObject = {...camposBasicos, ...camposDomicilioReal, ...camposDomicilioLegal, ...datosUsuario}

      const attributeName = 'usuario'
      const formData =  new FormData();
      for(const [_, value] of Object.entries(newObject)){
        if(value.atributo){
          if (value.atributo.includes('.')) {
            const [parentKey, childKey] = value.atributo.split('.');

            formData.append(`${attributeName}[${parentKey}_attributes][${childKey}]`, value.value || '')

          } else {
            formData.append(`${attributeName}[${value.atributo}]`, value.value || '')
          }
        }
      }

      formData.append(`skip_password_validation`, true)

      await resourcesServices.crearResource('usuarios/validarContenido', formData);

      setSaving(false)
      alert("Datos Válidos")

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(window.confirm('Está seguro que quiere activar al obligado?')) {
      guardarObligado()
    }
  }

  const handleInput = (e, section) => {
    let { name, value, files, type } = e.target;

    if (name.includes('.')) {
      const [parentKey, childKey] = name.split('.');
      name = childKey
    }

    if(section === 'camposBasicos'){
      const updatedCamposBasicos = { ...camposBasicos };
      if (Object.hasOwnProperty.call(updatedCamposBasicos, name)) {
        updatedCamposBasicos[name].value = value;
      }
      console.log(updatedCamposBasicos)
      setCamposBasicos(updatedCamposBasicos);
    } else if(section === 'camposDomicilioLegal'){
      const updatedCamposDomicilioLegal = { ...camposDomicilioLegal };
      if (Object.hasOwnProperty.call(updatedCamposDomicilioLegal, name)) {
        updatedCamposDomicilioLegal[name].value = value;
      }
      setCamposDomicilioLegal(updatedCamposDomicilioLegal);
    } else if(section === 'camposDomicilioReal'){
      const updatedCamposDomicilioReal = { ...camposDomicilioReal };
      if (Object.hasOwnProperty.call(updatedCamposDomicilioReal, name)) {
        updatedCamposDomicilioReal[name].value = value;
      }
      setCamposDomicilioReal(updatedCamposDomicilioReal);
    } else if(section === 'datosUsuario'){
      const updatedDatosUsuario = { ...datosUsuario };
      if (Object.hasOwnProperty.call(updatedDatosUsuario, name)) {
        if(type==='file'){
          updatedDatosUsuario[name] = files;
        } else {
          updatedDatosUsuario[name].value = value;
        }
      }
      setDatosUsuario(updatedDatosUsuario);
    }
  }

  return (
    <div>
      {renderHTML && (
        <>
        <h1>Creación de Obligado <BotonVolver /></h1>
        {
          usuario && usuario.id && (
            <div className="alert alert-success" role="alert">
              Existe un usuario con este documento
            </div>
          )
        }
        {
          camposBasicos && camposDomicilioReal && camposDomicilioLegal && (
          <form onSubmit={handleFormSubmit}>
            <div className="row mt-3">
              <div className="col-6">
                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Información personal</h5>
                    {
                      Object.entries(camposBasicos).map(([key, value]) => (
                        <div key={key}>
                          <TextControlObligado
                            autocompletar={value.autocompletar}
                            required={value.requerido}
                            label={value.label}
                            disabled={true}
                            value={value.value}
                            options={value.options || []}
                            type={value.tipo}
                            attributeModelName={value.atributo || key}
                            handleInput={(e) => handleInput(e, 'camposBasicos')}
                          />
                        </div>
                      ))
                    }
                  </div>
                </div>

                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Datos de Usuario</h5>
                    {/* <pre>{JSON.stringify(datosUsuario, null, 2)}</pre> */}
                    {
                      Object.entries(datosUsuario).map(([key, value]) => (
                        <div key={key}>
                          <TextControlObligado
                            autocompletar={value.autocompletar}
                            value={value.value}
                            disabled={true}
                            options={value.options || []}
                            type={value.tipo}
                            attributeModelName={value.atributo || key}
                            handleInput={(e) => handleInput(e, 'datosUsuario')}
                          />
                        </div>
                      ))
                    }
                    {/* <input
                      placeholder="Adjunte los documentos"
                      className="form-control"
                      onChange={handleFileChange}
                      name="documentos"
                      type="file"
                      id="documentos"
                      multiple
                    /> */}

                  </div>
                </div>

              </div>
              <div className="col-6">
                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Domicilio Real</h5>
                    {
                      Object.entries(camposDomicilioReal).map(([key, value]) => (
                        <div key={key}>
                          <TextControlObligado
                            autocompletar={value.autocompletar}
                            disabled={true}
                            value={value.value}
                            options={value.options || []}
                            type={value.tipo}
                            attributeModelName={value.atributo || key}
                            handleInput={(e) => handleInput(e, 'camposDomicilioReal')}
                            />
                        </div>
                      ))
                    }
                  </div>
                </div>

                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Domicilio Legal</h5>
                    {
                      Object.entries(camposDomicilioLegal).map(([key, value]) => (
                        <div key={key}>
                          <TextControlObligado
                            autocompletar={value.autocompletar}
                            value={value.value}
                            disabled={true}
                            options={value.options || []}
                            type={value.tipo}
                            attributeModelName={value.atributo || key}
                            handleInput={(e) => handleInput(e, 'camposDomicilioLegal')}
                          />
                        </div>
                      ))
                    }
                  </div>
                </div>

              </div>
            </div>
            {
              registroPdf.usuario && registroPdf.usuario.id && (
                <>
                <div className='alert alert-warning' role='alert'>
                  <b>Existe un usuario con este documento.</b><br />
                  Al guardar se van a actualizar los datos del usuario existente con los nuevos datos. <br />
                  La información del cargo anterior se va a archivar para ser reempazado por este nuevo cargo.
                </div>
                <div className='alert alert-warning' role='alert'>
                  <b>Nombre completo:</b> {registroPdf.usuario.nombre + ' ' + registroPdf.usuario.apellido}<br />
                  <b>Documento:</b> {registroPdf.usuario.documento_identidad}<br />
                  <b>Email:</b> {registroPdf.usuario.email}<br />
                  <b>Usuario:</b> {registroPdf.usuario.usuario}<br />
                </div>
                </>
              )
            }

            <button disabled={saving} className="btn btn-primary mt-3" type="submit">
              {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
              <span role="status">Aprobar</span>
            </button>

          </form>
          )
        }
        </>
      )}
    </div>
  );
};

export default ObligadoForm;